// simple abstraction to get data
import axios from 'axios';
import { DATA_SOURCE_URL } from "./constants.js";

// future server get data function
async function getDataServer(dataName, accessToken) {
  // axios get data
  if (dataName){
    let schema = await axios({
      method: 'GET',
      // TBD use urljoin
      url: `${DATA_SOURCE_URL}${dataName}`,
      headers: {"Authorization": `Bearer ${accessToken.jwtToken}`}
    });
    let data = schema["data"];
    return (data);
  }
}

// current import based
// async function getDataImport(dataName) {
//   // The json import is only possible because of the js loader.  It's unsupported in most current js engines.
//   import NetworkJson from "../assets/data/EIN_Orgs_connected.json";
//   return (JSON.parse(NetworkJson));
// }

// maybe future amplify/s3 based data storage


// change export according to where you want the data from
export { getDataServer as getData }
